import React, { useEffect } from "react"

import { CircularProgress } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Alert } from "@cirrus/ui-kit-ts/src/components/molecules/Alert"

import { useCustomerInfo } from "../../CustomerInfo"
import { useLoginFetcher, useLoginService } from "../providers/LoginService"
import { useNavigationService } from "../providers/NavigationService"


export const MasterLogin = () => {
  const { i18n } = useTranslations()
  const { redirectToApp, search } = useNavigationService()
  const { login, error } = useLoginFetcher()
  const { persistLoginPreferences } = useLoginService()
  const customerInfoContext = useCustomerInfo()

  useEffect(() => {
    !!search?.session && !!customerInfoContext.data?.defaultLanguage && login(({
      grant_type: "master_session_token", browser_token: null
    }), { session: search.session }).then(({ data }) => {
      persistLoginPreferences({
        language: customerInfoContext.data?.defaultLanguage ?? "en-GB", loggedInByKeycode: false, loggedInAsUser: true
      })

      redirectToApp(data)
    }).catch(console.error)
  }, [search?.session && customerInfoContext.data?.defaultLanguage])

  if (error?.error === "invalid_client") return <Alert icon={false}
                                                       severity="error">{i18n("Login:NotAllowedIp")}</Alert>

  if (error?.error === "invalid_grant") return <Alert icon={false}
                                                      severity="error">{i18n("Login:InvalidSessionToken")}</Alert>

  return <CircularProgress style={{ margin: "2rem auto" }}/>
}
